import dayjs, { ConfigType } from 'dayjs';

export const isToday = (date: ConfigType) => {
  return dayjs().isSame(date, 'day');
};
